/**
 * Analytics mixin
 * This mixin intercepts event dispatches on a custom element so that they can additionally be sent to an analytics service.
 */
const Analytics = (superClass) => {
    class AnalyticsClass extends superClass {
        constructor() {
            super(...arguments);
            this.pushData = (params) => {
                window?.dataLayer?.push(params);
            };
        }
        dispatchEvent(event) {
            const { pushData } = this;
            const payload = {
                event: event.type,
                eventContext: this.testAndAnalyticsContext || this.nodeName.toLowerCase(),
                ...(event instanceof CustomEvent && event.detail && { eventDetail: event.detail }),
            };
            pushData(payload);
            return super.dispatchEvent(event);
        }
    }
    return AnalyticsClass;
};
export default Analytics;
